import { useEffect } from "react";
import { withRouter, type RouteComponentProps } from "react-router-dom";

import { createCookie, readCookie } from "./functions";

const COMPLETE_PROFILE_PATH = "/client/seller/complete-profile";
const CARGO_FORM = "cargo_form";

const cleanCargoFormFromCookie = (): void => {
	const raw = readCookie("UTM") as string | undefined;
	if (!raw) {
		return;
	}
	try {
		const parsed = JSON.parse(decodeURIComponent(raw)) as Record<
			string,
			unknown
		>;
		const utmTerm = (parsed?.utm_term ?? "").toString().toLowerCase();
		if (!utmTerm.includes(CARGO_FORM)) {
			return;
		}
		delete parsed.utm_term;
		createCookie(
			"UTM",
			JSON.stringify(parsed),
			true,
			30 * 24 * 60 * 60 * 1000,
			"/",
			true,
			true
		);
	} catch (err) {
		console.error("Failed to clean cargo_form from UTM cookie:", err);
	}
};

function CargoFormRedirect({ history }: RouteComponentProps) {
	useEffect(() => {
		const url =
			`${window.location.pathname}${window.location.search}${window.location.hash}`.toLowerCase();

		let utmTerm = "";
		const utmCookie = readCookie("UTM") as string | undefined;
		if (utmCookie) {
			try {
				const parsed = JSON.parse(decodeURIComponent(utmCookie)) as {
					utm_term?: string;
				};
				utmTerm = (parsed?.utm_term ?? "").toString().toLowerCase();
			} catch {
				// malformed cookie — ignore
			}
		}

		const hasCargoForm =
			url.includes(CARGO_FORM) || utmTerm.includes(CARGO_FORM);
		if (!hasCargoForm) {
			return;
		}

		if (history.location.pathname !== COMPLETE_PROFILE_PATH) {
			history.replace(COMPLETE_PROFILE_PATH);
		}
		cleanCargoFormFromCookie();
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount to handle deep-link UTM redirect
	}, []);

	return null;
}

export default withRouter(CargoFormRedirect);
